
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Diagnose from '@/types/Diagnose';
    import { DiagnosenFilter, LoadDiagnosenPayload } from '@/store/diagnosen';
    import { DataTableHeaders } from '@/types';
    import DiagnosenDetail from '@/components/Diagnosen/DiagnosenDetail.vue';

    @Component({
        components: {
            DiagnosenDetail,

        },
        computed: {
            ...mapState('diagnosen', ['diagnosen', 'dialogs', 'loaders']),
            ...mapState('authentication', ['impfstelle_id']),
        },
        methods: {
            ...mapActions('diagnosen', ['loadDiagnosen']),
            ...mapMutations('diagnosen', ['setDialogsDetail']),
        },
    })
    export default class Diagnosen extends Vue {
        public diagnose = new Diagnose();

        public search = '';

        public filter: DiagnosenFilter = {
            gueltig: 'j',
        };

        public diagnosen!: Diagnose[];
        public loadDiagnosen!: (payload?: LoadDiagnosenPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public currentSort: { by: (string | undefined)[]; desc: (boolean | undefined)[] } = { by: [], desc: [] };

        public get headers(): DataTableHeaders<Diagnose> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Diagnose', value: 'diagnose' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        @Watch('dialogs.edit')
        public onChangeDiagnosenDialog(visible: boolean): void {
            if (!visible) {
                this.diagnose = new Diagnose();
            }
        }

        public mounted(): void {
            this.onChangeFilter();
        }

        public onChangeFilter(): void {
            this.loadDiagnosen({ filter: this.filter});
        }

        public onClickEdit(diagnose: Diagnose): void {
            this.diagnose = new Diagnose(diagnose);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.diagnose = new Diagnose();
            this.setDialogsDetail(true);
        }

        public getSortedDiagnosen(): Diagnose[] {
            const [key] = this.currentSort.by;
            const [desc] = this.currentSort.desc;

            if (key === undefined || desc === undefined) {
                return this.diagnosen;
            }

            type comparator = (a: Diagnose, b: Diagnose) => number;

            /* eslint-disable @typescript-eslint/no-explicit-any */
            const by = (desc: boolean): comparator => desc
                ? (a: any, b: any): number => {
                    const v1 = a[key];
                    const v2 = b[key];
                    return v1 === v2 ? 0 : v1 > v2 ? -1 : 1;
                } : (a: any, b: any): number => {
                    const v1 = a[key];
                    const v2 = b[key];
                    return v1 === v2 ? 0 : v1 > v2 ? 1 : -1;
                };

            return this.diagnosen.sort(by(desc));
        }

        public onClickPrevious(): void {
            const Diagnosen = this.getSortedDiagnosen();
            if (Diagnosen.length === 0) {
                return;
            }

            const index = Diagnosen.map(({ diagnose_id }) => diagnose_id).indexOf(this.diagnose.diagnose_id);

            this.diagnose = {
                ...(index === 0)
                    ? Diagnosen[Diagnosen.length - 1]
                    : Diagnosen[index - 1],
            };
        }

        public onClickNext(): void {
            const Diagnosen = this.getSortedDiagnosen();
            if (Diagnosen.length === 0) {
                return;
            }

            const index = Diagnosen.map(({ diagnose_id }) => diagnose_id).indexOf(this.diagnose.diagnose_id);

            this.diagnose = {
                ...(index === Diagnosen.length - 1)
                    ? Diagnosen[0]
                    : Diagnosen[index + 1],
            };
        }

        public onClickClose(): void {
            this.setDialogsDetail(false);
        }

        public onUpdateSortBy(by: string[]): void {
            this.currentSort.by = by;
        }

        public onUpdateSortDesc(desc: boolean[]): void {
            this.currentSort.desc = desc;
        }
    }
